"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var parseAddress = function parseAddress(place) {
  if (place && place.street && place.city && place.zipCode) {
    var city = place.city,
        street = place.street,
        streetNumber = place.streetNumber,
        zipCode = place.zipCode;
    return {
      city: city,
      street: street,
      streetNumber: streetNumber,
      zipCode: zipCode
    };
  }

  if (place && place.full) {
    var _ref = [].concat((0, _toConsumableArray2.default)(place.full.split(',').map(function (i) {
      return i.trim();
    })), [undefined, undefined, undefined]),
        _ref$ = _ref[0],
        streetLine = _ref$ === void 0 ? '' : _ref$,
        _city = _ref[1],
        _zipCode = _ref[2];

    var _street = streetLine.trim().substring(0, streetLine.lastIndexOf(' '));

    var _streetNumber = streetLine.trim().substring(streetLine.lastIndexOf(' ') + 1);

    return {
      city: _city,
      streetNumber: _streetNumber,
      street: _street,
      zipCode: _zipCode
    };
  }

  return place;
};

var mapCustomerToCheckout = function mapCustomerToCheckout(customer) {
  return customer ? {
    invoiceInfo: (0, _extends2.default)({
      firstName: customer.firstName,
      lastName: customer.lastName
    }, parseAddress(((customer.postaddresses || []).find(function (_ref2) {
      var type = _ref2.type;
      return type === 'hq';
    }) || {}).place), {
      country: customer.country,
      phoneNumber: ((customer.phones || []).find(function (_ref3) {
        var type = _ref3.type;
        return type === 'main';
      }) || {}).number,
      emailAddress: ((customer.emails || []).find(function (_ref4) {
        var type = _ref4.type;
        return type === 'home';
      }) || {}).address
    })
  } : {};
};

var _default = mapCustomerToCheckout;
exports.default = _default;